import { COMPILER_OPTIONS, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Data } from '@angular/router';
import { APIResponse } from 'src/app/shared/models/api-response';
import { Student } from 'src/app/shared/models/student';
import { Level } from 'src/app/shared/models/student_level';
import { HttpErrorResponse } from '@angular/common/http';
import { HandleRequestService } from 'src/app/shared/services/handle-request.service';
import { lang } from 'src/lang/lang';
import {
  ApexAxisChartSeries,
  ApexChart,
  ChartComponent,
  ApexDataLabels,
  ApexXAxis,
  ApexPlotOptions
} from "ng-apexcharts";

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  colors: string[];
  xaxis: ApexXAxis;
};
@Component({
  selector: 'app-level',
  templateUrl: './level.component.html',
  styleUrls: ['./level.component.css']
})


export class LevelComponent implements OnInit {
  levelInfo: Level;
  student: Student;
  studentProgress: any;
  noProgress = false;
  series: ApexAxisChartSeries;
  chart: ApexChart;
  todayPoints = 0;
  todayProgresses = [];
  progresses = {};
  lang = lang;
  locale = 'es';
  public chartOptionsPoint: Partial<ChartOptions>;
  public chartOptionsSpeed: Partial<ChartOptions>;

  isChart = false;

  selectedLevel: any;

  globalLevel = {
    points: 0,
    static_points: 0,
    audible_points: 0,
    flash_points: 0,
    static_time: 0,
    audible_speed: 0,
    flash_speed: 0,
  };

  selectedPointChartType = 'all'; // all, s, a, f
  selectedSpeedChartType = 's'; // s, a, f

  constructor(private route: ActivatedRoute, private handleRequest: HandleRequestService) { }

  ngOnInit() {
    var ln = localStorage.getItem('locale');
    if (ln != null) {
      this.locale = ln;
    }
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();
    const day = now.getDate();
    const today = new Date(year, month, day);
    const tomorrow = this.addDays(today, 1);

    this.route.data.subscribe((data: Data) => {
      if (data.hasOwnProperty('profile')) {
        const response = data.profile as APIResponse;
        if (!response.error) {
          this.student = response.data;
        }
      }

      if (data.hasOwnProperty('levels')) {
        const response = data.levels as APIResponse;
        if (!response.error) {
          this.levelInfo = response.data;
        }
      }

      if (data.hasOwnProperty('progress')) {
        const response = data.progress as APIResponse;
        if (!response.error) {
          this.studentProgress = response.data;
          this.noProgress = Object.keys(this.studentProgress).length === 0 && this.studentProgress.constructor === Object;
          for (var item of this.studentProgress.level_points) {
            this.progresses[item.level] = item;
          }
          this.checkCurrentLevel();
          this.updatePointChart();
          this.updateSpeedChart();
        }
      }

    });
  }

  getAvatar() {

    if (typeof this.student.avatar != "object") {
      return this.student.avatar;
    } else {
      return 'assets/images/avatar.png';
    }
  }

  checkCurrentLevel() {
    const levels = this.levelInfo.levels;
    let currentIndex;
    // tslint:disable-next-line: prefer-for-of
    for (let i in levels) {
      if (!this.noProgress && levels[i]._id === this.studentProgress.level) {
        currentIndex = i;
      }
      if (!isNaN(currentIndex)) {
        if (currentIndex > i) {
          levels[i].status = 'done';
          var progress = this.progresses[levels[i]._id];
          if (progress) {
            if (progress.points == -1) {
              levels[i].points = 100;
              levels[i].static_points = 100;
              levels[i].audible_points = 100;
              levels[i].flash_points = 100;
              levels[i].static_time = 0;
              levels[i].audible_speed = 0;
              levels[i].flash_speed = 0;
            } else {
              levels[i].points = progress.points;
              levels[i].static_points = progress.static_points || progress.points;
              levels[i].audible_points = progress.audible_points || progress.points;
              levels[i].flash_points = progress.flash_points || progress.points;
              levels[i].static_time = progress.static_time;
              levels[i].audible_speed = progress.audible_speed;
              levels[i].flash_speed = progress.flash_speed;
            }

            levels[i].date = this.convertMillisecondsToDate(progress.date);

          } else {
            levels[i].points = 100;
            levels[i].static_points = 100;
              levels[i].audible_points = 100;
              levels[i].flash_points = 100;
              levels[i].static_time = 0;
              levels[i].audible_speed = 0;
              levels[i].flash_speed = 0;
            levels[i].date = "12 Jan 22";
          }
        } else if (currentIndex < i) {
          levels[i].status = 'pending';
        } else {
          levels[i].status = 'current';
          var progress = this.progresses[levels[i]._id];
          if (progress) {
            if (progress.points == -1) {
              levels[i].points = 100;
              levels[i].static_points = 100;
              levels[i].audible_points = 100;
              levels[i].flash_points = 100;
              levels[i].static_time = 0;
              levels[i].audible_speed = 0;
              levels[i].flash_speed = 0;
            } else {
              levels[i].points = progress.points;
              levels[i].static_points = progress.static_points || progress.points;
              levels[i].audible_points = progress.audible_points || progress.points;
              levels[i].flash_points = progress.flash_points || progress.points;
              levels[i].static_time = progress.static_time;
              levels[i].audible_speed = progress.audible_speed;
              levels[i].flash_speed = progress.flash_speed;
            }

            levels[i].date = this.convertMillisecondsToDate(progress.date);

          } else {
            levels[i].points = 100;
            levels[i].static_points = 100;
              levels[i].audible_points = 100;
              levels[i].flash_points = 100;
              levels[i].static_time = 0;
              levels[i].audible_speed = 0;
              levels[i].flash_speed = 0;
            levels[i].date = "12 Jan 22";
          }
        }
      } else {
        levels[i].status = 'done';
        var progress = this.progresses[levels[i]._id];
        if (progress) {
          if (progress.points == -1) {
            levels[i].points = 100;
            levels[i].static_points = 100;
            levels[i].audible_points = 100;
            levels[i].flash_points = 100;
            levels[i].static_time = 0;
            levels[i].audible_speed = 0;
            levels[i].flash_speed = 0;
          } else {
            levels[i].points = progress.points;
            levels[i].static_points = progress.static_points || progress.points;
            levels[i].audible_points = progress.audible_points || progress.points;
            levels[i].flash_points = progress.flash_points || progress.points;
            levels[i].static_time = progress.static_time;
            levels[i].audible_speed = progress.audible_speed;
            levels[i].flash_speed = progress.flash_speed;
          }

          levels[i].date = this.convertMillisecondsToDate(progress.date);

        } else {
          levels[i].points = 100;
          levels[i].static_points = 100;
          levels[i].audible_points = 100;
          levels[i].flash_points = 100;
          levels[i].static_time = 0;
          levels[i].audible_speed = 0;
          levels[i].flash_speed = 0;
          levels[i].date = "Jan 12, 2022";
        }
      }
    }

    this.globalLevel = {
      points: 0,
      static_points: 0,
      audible_points: 0,
      flash_points: 0,
      static_time: 0,
      audible_speed: 0,
      flash_speed: 0,
    };

    let count = 0;

    for (let i in levels) {
      if (levels[i].points != 0 && levels[i].status != 'pending') {
        count++;
        this.globalLevel.points += levels[i].points;
        this.globalLevel.static_points += levels[i].static_points;
        this.globalLevel.audible_points += levels[i].audible_points;
        this.globalLevel.flash_points += levels[i].flash_points;
        this.globalLevel.static_time += levels[i].static_time;
        this.globalLevel.audible_speed += levels[i].audible_speed;
        this.globalLevel.flash_speed += levels[i].flash_speed;
      }
    }
    console.log(this.globalLevel);

    if (count > 0) {
      this.globalLevel.points = Math.round(this.globalLevel.points/count);
      this.globalLevel.static_points = Math.round(this.globalLevel.static_points/count);
      this.globalLevel.audible_points = Math.round(this.globalLevel.audible_points/count);
      this.globalLevel.flash_points = Math.round(this.globalLevel.flash_points/count);
      this.globalLevel.static_time = Math.round(this.globalLevel.static_time/count);
      this.globalLevel.audible_speed = Math.round(this.globalLevel.audible_speed/count);
      this.globalLevel.flash_speed = Math.round(this.globalLevel.flash_speed/count);
    }

    console.log(this.globalLevel);
  }

  addDays(date, days) {
    var result = new Date(date);
    result.setDate(date.getDate() + days);
    return result;
  }

  convertMillisecondsToDate(milliseconds) {
    const dateObject = new Date(milliseconds)

    const humanDateFormat = dateObject.toLocaleString("en-US", { day: "numeric", month: "short", year: "numeric" });

    return humanDateFormat;
  }

  updatePointChart() {

    let chartName = "Nivel de aciertos";
    let chartData = [];
    let labelUnit = "";
    let chartCategories = [];

    for (let i in this.levelInfo.levels) {
      chartCategories.push(`${lang[this.locale]['level']} ${this.levelInfo.levels[i].step}`)
      if (this.levelInfo.levels[i].status == 'pending') {
        chartData.push(1);
      } else {
        if (this.selectedPointChartType == 'all') {
          chartData.push(this.levelInfo.levels[i].points);
        } else if (this.selectedPointChartType == 's') {
          chartData.push(this.levelInfo.levels[i].static_points);
        } else if (this.selectedPointChartType == 'a') {
          chartData.push(this.levelInfo.levels[i].audible_points);
        } else if (this.selectedPointChartType == 'f') {
          chartData.push(this.levelInfo.levels[i].flash_points);
        }
      }

    }

    this.chartOptionsPoint = {
      series: [
        {
          name: chartName,
          data: chartData
        }
      ],
      chart: {
        height: 350,
        type: "bar",
      },
      plotOptions: {
        bar: {
          dataLabels: {
            position: "top" // top, center, bottom
          },
          colors: {
            ranges: [
              {
                from: 1,
                to: 1,
                color: "#9CA3AF"
              },
              {
                from: 2,
                to: 21,
                color: "#FF9F3D"
              },
              {
                from: 21,
                to: 51,
                color: "#FFCE20"
              },
              {
                from: 51,
                to: 100,
                color: "#8DBB40"
              }
            ]
          },
        },
        
      },
      dataLabels: {
        enabled: true,
        formatter: function (val) {
          if (val == 1) {
            return '🔒';
          }
          return val + labelUnit;
        },
        offsetY: -20,
        style: {
          fontSize: "14px",
          colors: ["#304758"]
        }
      },
      xaxis: {
        categories: chartCategories
      }
    };
  }

  updateSpeedChart() {
    let chartName = "Velocidad";
    let chartData = [];
    let labelUnit = "s";
    let chartCategories = [];

    for (let i in this.levelInfo.levels) {
      chartCategories.push(`${lang[this.locale]['level']} ${this.levelInfo.levels[i].step}`)
      if (this.levelInfo.levels[i].status == 'pending') {
        chartData.push(1);
      } else {
        if (this.selectedSpeedChartType == 's') {
          chartData.push(this.levelInfo.levels[i].static_time);
          labelUnit = "s";
          chartName = "tiempo"
        } else if (this.selectedSpeedChartType == 'a') {
          chartData.push(this.levelInfo.levels[i].audible_speed);
          labelUnit = "";
        } else if (this.selectedSpeedChartType == 'f') {
          chartData.push(this.levelInfo.levels[i].flash_speed);
          labelUnit = "";
        }
      }

    }

    this.chartOptionsSpeed = {
      series: [
        {
          name: chartName,
          data: chartData
        }
      ],
      chart: {
        height: 350,
        type: "bar",
      },
      plotOptions: {
        bar: {
          dataLabels: {
            position: "top" // top, center, bottom
          },
          colors: {
            ranges: [
              {
                from: 1,
                to: 1,
                color: "#9CA3AF"
              },
              {
                from: 2,
                to: 21,
                color: "#FF9F3D"
              },
              {
                from: 21,
                to: 51,
                color: "#FFCE20"
              },
              {
                from: 51,
                to: 100,
                color: "#8DBB40"
              }
            ]
          },
        },
        
      },
      dataLabels: {
        enabled: true,
        formatter: function (val) {
          if (val == 1) {
            return '🔒';
          }
          return val + labelUnit;
        },
        offsetY: -20,
        style: {
          fontSize: "14px",
          colors: ["#304758"]
        }
      },
      xaxis: {
        categories: chartCategories
      }
    };
  }

  changeSelectedPointChartType(type) {
    this.selectedPointChartType = type;
    setTimeout(() => this.updatePointChart(), 500);
  }

  changeSelectedSpeedChartType(type) {
    this.selectedSpeedChartType = type;
    setTimeout(() => this.updateSpeedChart(), 500);
  }

  selectLevel (l) {
    if (l.status == 'pending') {
      return;
    }
    this.selectedLevel = l;
  }
}
